import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastItem } from '../item/toast-item.model';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { LoggerService } from 'projects/shared/lib/services/infrastructure/logger/logger.service';

import { ToastItemBaseComponent } from '../item/toast-item.component';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  imports: [ToastItemBaseComponent]
})
export class ToastContainerBaseComponent implements OnInit, OnDestroy {
  private logger: LoggerService;
  private readonly toastService: IToastService = inject(IToastServiceToken);
  private toastItemAddSubscription: Subscription | undefined;

  public toastItemList: ToastItem[];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.logger = ServiceLocator.injector.get(LoggerService);

    this.toastItemList = [];
  }

  public ngOnInit(): void {
    if (!this.toastItemAddSubscription) {
      this.toastItemAddSubscription = this.toastService.toastItemAddSubject().subscribe({
        next: (toastItem: ToastItem) => {
          this.logger.trace(`ToastContainerBaseComponent-toastItemAddSubscription.next()`, this.constructor.name);
          this.toastItemList.push(toastItem);
          this.changeDetectorRef.detectChanges();
        }
      });
    }

    // this.displayAllToastVariantsUponInit(); // for Debug/Design purposes
  }

  private displayAllToastVariantsUponInit() {
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Default,
      title: 'Default',
      message: 'Default',
      autohide: false
    }));
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Primary,
      title: 'Primary',
      message: 'Primary',
      autohide: false
    }));
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Secondary,
      title: 'Secondary',
      message: 'Secondary',
      autohide: false
    }));
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Success,
      title: 'Success',
      message: 'Success',
      autohide: false
    }));
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Danger,
      title: 'Danger',
      message: 'Danger',
      autohide: false
    }));
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Warning,
      title: 'Warning',
      message: 'Warning',
      autohide: false
    }));
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Info,
      title: 'Info',
      message: 'Info',
      autohide: false
    }));
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Light,
      title: 'Light',
      message: 'Light',
      autohide: false
    }));
    this.toastService.toastItemAdd(new ToastItem({
      type: EToastItemType.Dark,
      title: 'Dark',
      message: 'Dark',
      autohide: false
    }));
  }

  public ngOnDestroy(): void {
    if (this.toastItemAddSubscription) {
      this.toastItemAddSubscription.unsubscribe();
    }
  }

  public toastRemove(toastItem: ToastItem) {
    let matchIndex = this.toastItemList.findIndex(
      (toastListEntry: ToastItem) => {
        // note: might not be unique enough for very rare cases
        return toastListEntry.id == toastItem.id && toastListEntry.title == toastItem.title;
      }
    );
    if (matchIndex >= 0) {
      this.toastItemList.splice(matchIndex, 1);
    }
  }

}
